import React, { useMemo } from 'react';
import bkkLogo from 'images/landingpages/bkk/bertelsmann-bkk-logo.svg';
import gothaerLogo from 'images/landingpages/gothaer/gothaer-logo.svg';
import { useLocation } from 'react-router-dom';
import { linkHandler } from 'utils/linkHandler';

const cooperations = {
  gothaer: {
    logo: gothaerLogo,
    url: 'https://www.gothaer.de/',
    altText: 'gothaer-logo'
  },
  bkk: {
    logo: bkkLogo,
    url: 'https://www.bertelsmann-bkk.de/balloon',
    altText: 'bertelsmann-bkk-logo'
  }
};

export const CooperationLogo = () => {
  const location = useLocation();
  const cooperation = useMemo(() => {
    for (const key in cooperations) {
      const route = linkHandler.getRoute(key);
      if (route && location.pathname === route.path) {
        return cooperations[key];
      }
    }
    return null;
  }, [location]);

  if (!cooperation) {
    return null;
  }

  return (
    <a className="brand-logo" target="_blank" rel="noopener noreferrer" href={cooperation.url}>
      <img src={cooperation.logo} alt={cooperation.altText} />
    </a>
  );
};
